import { spriteSheet } from 'engine/facets/SpriteFacet';
import botElectricity01 from './images/bot-electricity-01.png';
import botElectricity02 from './images/bot-electricity-02.png';

export const BotElectricity = spriteSheet({
  off: { frames: [], fps: 0 },
  on: {
    frames: [
      <image href={botElectricity01} opacity={0.85} />,
      <image href={botElectricity02} />,
    ],
    fps: 18,
  },
});
